export default {
  // Set up your line section
  setUpYourLineLabel: {
    id: 'checkout_services_bouygues_phoneline_setup_set_up_your_line_label',
    defaultMessage: 'Set up your line',
  },
  keepPhoneNumberLabel: {
    id: 'checkout_services_bouygues_phoneline_setup_keep_phone_number_label',
    defaultMessage: 'Keep current phone number',
  },
  newPhoneNumberLabel: {
    id: 'checkout_services_bouygues_phoneline_setup_new_phone_number_label',
    defaultMessage: 'Get a new phone number',
  },
  simCardShippingInfo: {
    id: 'checkout_services_bouygues_phoneline_setup_sim_card_shipping_info',
    defaultMessage:
      'Bouygues Telecom will deliver your new SIM card within 6 business days after confirmation.',
  },
  phoneNumberTitle: {
    id: 'checkout_services_bouygues_phoneline_setup_set_up_your_line_phone_number_title',
    defaultMessage: "What's your current number?",
  },
  phoneNumberSubtitle: {
    id: 'checkout_services_bouygues_phoneline_setup_set_up_your_line_phone_number_subtitle',
    defaultMessage:
      'Bouygues Telecom handles everything with your current carrier to make the contract switch.',
  },
  phoneNumberInputLabel: {
    id: 'checkout_services_bouygues_phoneline_setup_set_up_your_line_phone_number_input_label',
    defaultMessage: 'Phone number',
  },
  phoneNumberInputClear: {
    id: 'checkout_services_bouygues_phoneline_setup_set_up_your_line_phone_number_input_clear',
    defaultMessage: 'clear',
  },
  phoneNumberInputErrorInvalid: {
    id: 'checkout_services_bouygues_phoneline_setup_set_up_your_line_phone_number_input_error_invalid',
    defaultMessage: 'Enter a valid french phone number',
  },
  RIO: {
    id: 'checkout_services_bouygues_phoneline_setup_set_up_your_line_RIO',
    defaultMessage: 'RIO',
  },
  RIODescription: {
    id: 'checkout_services_bouygues_phoneline_setup_set_up_your_line_RIO_description',
    defaultMessage:
      'Your unique relevé d’identité opérateur (RIO) number is used by Bouygues Telecom to transfer your phone number as you change contracts.',
  },
  RIOInfoBlockTitle: {
    id: 'checkout_services_bouygues_phoneline_setup_set_up_your_line_RIO_info_block_title',
    defaultMessage: 'Get your RIO number',
  },
  RIOInfoBlockContent: {
    id: 'checkout_services_bouygues_phoneline_setup_set_up_your_line_RIO_info_block_content',
    defaultMessage:
      'Call the number below, and an automated service will instantly text you your RIO number for free.',
  },
  RIOInfoBlockLink: {
    id: 'checkout_services_bouygues_phoneline_setup_set_up_your_line_RIO_info_block_link',
    defaultMessage: 'Call 3179 for RIO number',
  },
  RIOInputErrorInvalid: {
    id: 'checkout_services_bouygues_phoneline_setup_payment_input_RIO_input_error_invalid',
    defaultMessage:
      'Enter the correct RIO number that matches your phone number or call below to get yours.',
  },

  // Payment information section
  paymentInformationLabel: {
    id: 'checkout_services_bouygues_phoneline_setup_payment_information_label',
    defaultMessage: 'Payment information',
  },
  IBAN: {
    id: 'checkout_services_bouygues_phoneline_setup_payment_IBAN',
    defaultMessage: 'IBAN',
  },
  IBANDescription: {
    id: 'checkout_services_bouygues_phoneline_setup_payment_input_IBAN_description',
    defaultMessage:
      'This will be used for Bouygues Telecom monthly phone plan payments.',
  },
  IBANInputErrorInvalid: {
    id: 'checkout_services_bouygues_phoneline_setup_payment_input_IBAN_input_error_invalid',
    defaultMessage: 'Enter the IBAN in the right format.',
  },
  IBANInputErrorAccountNotAllowed: {
    id: 'checkout_services_bouygues_phoneline_setup_payment_input_IBAN_input_error_account_not_allowed',
    defaultMessage: 'Enter the IBAN in the right format.',
  },

  // More options section
  moreOptionsLabel: {
    id: 'checkout_services_bouygues_phoneline_setup_more_options_label',
    defaultMessage: 'More options',
  },
  parentalControl: {
    id: 'checkout_services_bouygues_phoneline_setup_parental_control',
    defaultMessage: 'Free parental control',
  },
  parentalControlInformation: {
    id: 'checkout_services_bouygues_phoneline_setup_parental_control_information',
    defaultMessage: 'Add limits to your child’s line.',
  },
  parentalControlIconAlternativeText: {
    id: 'checkout_services_bouygues_phoneline_setup_parental_control_icon_alternative_text',
    defaultMessage: 'Lock icon',
  },
  parentalControlLink: {
    id: 'checkout_services_bouygues_phoneline_setup_parental_control_link',
    defaultMessage: 'Learn more',
  },

  // Terms and condition
  inputTermsAndConditionRequired: {
    id: 'checkout_services_bouygues_phoneline_setup_input_terms_and_condition_required',
    defaultMessage: 'You must agree to the terms and conditions to continue.',
  },

  // Others
  inputRequired: {
    id: 'checkout_services_bouygues_phoneline_setup_input_required',
    defaultMessage: 'This field is required',
  },
  submit: {
    id: 'checkout_services_bouygues_phoneline_setup_submit',
    defaultMessage: 'Agree and continue',
  },
  bouyguesAssistance: {
    id: 'checkout_services_bouygues_phoneline_setup_bouygues_assistance',
    defaultMessage: 'Bouygues assistance',
  },
  returnPolicy: {
    id: 'checkout_services_bouygues_phoneline_setup_return_policy',
    defaultMessage: `Vous disposez d’un délai de rétractation de 14 jours, que vous pouvez exercer en nous contactant au 1064 (prix de l’appel en fonction de votre opérateur dans {callPrice, html}), ou via le Formulaire de rétractation {withdrawalForm, html}.\n
    Si vous avez déjà activé vos services, nous vous facturerons vos consommations et le prorata de vos abonnements et options jusqu’à votre date de rétractation.`,
  },
  callPrice: {
    id: 'checkout_services_bouygues_phoneline_setup_call_price',
    defaultMessage: 'les tarifs',
  },
  withdrawalForm: {
    id: 'checkout_services_bouygues_phoneline_setup_withdrawal_form',
    defaultMessage: 'Formulaire de rétractation',
  },
}
